import { render, staticRenderFns } from "./CustomPageTable.vue?vue&type=template&id=01271392&scoped=true"
import script from "./CustomPageTable.vue?vue&type=script&lang=js"
export * from "./CustomPageTable.vue?vue&type=script&lang=js"
import style0 from "./CustomPageTable.vue?vue&type=style&index=0&id=01271392&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01271392",
  null
  
)

export default component.exports